const emailRe =
  /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;

export const validateEmail = (email) => {
  if (!email?.length || !String(email).toLowerCase().match(emailRe)) {
    throw new Error("Invalid email address!");
  }
};
